module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-ira001.0149a9cd.png";